var _path, _path2, _rect, _rect2, _path3, _ellipse, _ellipse2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEstateAllServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.3114 46.9061L80.4849 17.4414L61.334 40.1263V92.8711H95.3114V46.9061Z",
    fill: "#BFD9F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 45.7266H63.5988V92.8701H11.5V45.7266Z",
    fill: "#EAF5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.6211,
    y: 59.8701,
    width: 13.591,
    height: 14.1431,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9258,
    y: 64.5859,
    width: 11.3258,
    height: 28.2861,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2684 17.4414H29.2546L11.5 45.7275H63.5988L80.2684 17.4414Z",
    fill: "#00C968"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.9445,
    cy: 45.8419,
    rx: 19.5558,
    ry: 15.3653,
    fill: "#B2B2B2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.9445,
    cy: 43.0479,
    rx: 19.5558,
    ry: 15.3653,
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3568 51.2607L70.7474 38.5342H73.7943L76.0443 47.4873H76.1615L78.4349 38.5342H81.4583L83.7552 47.4404H83.8724L86.099 38.5342H89.1458L85.5365 51.2607H82.4193L80.0286 42.6357H79.8646L77.474 51.2607H74.3568Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstateAllServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcEstateAllServiceMainMobile.554295f29d15af6cfd5f15f5dbeff046.svg";
export { ForwardRef as ReactComponent };